import { classifyDqxRunStatus, type DqxRunOutcome } from "@/lib/dqxRunStatus";
import { nextDqxPollIntervalMs } from "@/lib/pipelinePolling";
import { interruptibleSleep } from "@/services/batchIngestionSession";
import { fetchDqxValidationJobStatus } from "@/services/api";

const DEFAULT_MAX_ATTEMPTS = 360;

export async function pollDqxRunUntilTerminal(
  runId: number,
  options?: {
    intervalMs?: number;
    maxAttempts?: number;
    signal?: AbortSignal;
  }
): Promise<DqxRunOutcome> {
  const maxAttempts = options?.maxAttempts ?? DEFAULT_MAX_ATTEMPTS;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    if (options?.signal?.aborted) {
      throw new DOMException("DQX polling aborted", "AbortError");
    }

    const status = await fetchDqxValidationJobStatus(runId);
    const outcome = classifyDqxRunStatus(status);
    if (outcome !== "running") {
      return outcome;
    }

    const intervalMs = options?.intervalMs ?? nextDqxPollIntervalMs(attempt);
    await interruptibleSleep(intervalMs, options?.signal);
  }

  throw new Error("DQX validation polling timed out");
}
